import styled from 'styled-components';
import { Link } from 'react-router-dom';
import BoxEmployee from '../../core/BoxEmployee';

const StyledBoxEmployee = styled(BoxEmployee)`
  max-width: 400px;
  background-color: ${props => props.theme.colors.grayLight};
`;

const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.dark};
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

export { StyledBoxEmployee, StyledLink };
